<script setup lang="ts">
import Icon from '@/components/commons/Icon.vue'

defineProps<{
  themeMode: 'light' | 'dark'
}>()

const emit = defineEmits<{
  'menu-click': []
  'collapse-toggle': []
  'theme-toggle': []
}>()
</script>

<template>
  <header class="topbar">
    <div class="topbar-left">
      <button
        type="button"
        class="topbar-icon-btn topbar-menu"
        aria-label="Открыть меню"
        @click="emit('menu-click')"
      >
        <Icon name="menu" :size="20" />
      </button>

      <button
        type="button"
        class="topbar-icon-btn topbar-collapse"
        aria-label="Свернуть боковую панель"
        @click="emit('collapse-toggle')"
      >
        <Icon name="panel-left" :size="18" />
      </button>
    </div>

    <div class="topbar-right">
      <button
        type="button"
        class="topbar-icon-btn topbar-theme"
        :aria-label="themeMode === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему'"
        @click="emit('theme-toggle')"
      >
        <Icon :name="themeMode === 'dark' ? 'sun' : 'moon'" :size="18" />
      </button>
    </div>
  </header>
</template>

<style scoped>
.topbar {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  height: 64px;
  flex: 0 0 64px;
  padding: 0 var(--sp-5);
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  box-shadow: var(--shadow-1);
}
.topbar-left {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  min-width: 0;
  flex: 0 0 auto;
}
.topbar-right {
  display: flex;
  align-items: center;
  gap: var(--sp-1);
  flex: 0 0 auto;
  margin-left: auto;
}
.topbar-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  border-radius: var(--r-ctrl);
  color: var(--muted);
  cursor: pointer;
  transition: background 120ms, color 120ms;
}
.topbar-icon-btn:hover {
  background: var(--bg-2);
  color: var(--ink);
}
.topbar-icon-btn:active {
  background: var(--surface-2);
}

@media (min-width: 768px) {
  .topbar-menu { display: none; }
}
@media (max-width: 767px) {
  .topbar { padding: 0 var(--sp-3); }
  .topbar-collapse { display: none; }
}
</style>
